import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "business-data-section" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_option_field = _resolveComponent("option-field")
  const _component_text_field = _resolveComponent("text-field")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.hasMoneyPayment)
      ? (_openBlock(), _createBlock(_component_base_notificator, {
          key: 0,
          type: "info",
          "can-close": false,
          class: "_mt-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.hadPaymentText) + " ", 1 /* TEXT */),
            _createElementVNode("a", {
              class: "gfu-link _tdu",
              rel: "noopener noreferrer",
              href: $data.contactUrl,
              target: "_blank"
            }, "contact us", 8 /* PROPS */, _hoisted_2),
            _cache[11] || (_cache[11] = _createTextVNode(". ", -1 /* CACHED */))
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_option_field, {
      modelValue: $data.model.accountType,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = $event => (($data.model.accountType) = $event)),
        $options.onAccountTypeChange
      ],
      name: "model.accountType",
      "display-name": "Account Type",
      layout: "columns",
      options: $options.accountTypeOptions,
      description: "Defines if the account belongs to an individual creator or a company. Business - Registered legal entity (e.g., LLC, Inc.). Individual - Uses personal bank account or bank account established on a sole proprietorship.",
      required: "",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "account-type"
    }, null, 8 /* PROPS */, ["modelValue", "options", "read-only", "onUpdate:modelValue"]),
    ($options.isBusiness)
      ? (_openBlock(), _createBlock(_component_text_field, {
          key: 1,
          modelValue: $data.model.companyName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.companyName) = $event)),
          name: "model.companyName",
          "display-name": "Company name",
          layout: "columns",
          "read-only": $props.hasMoneyPayment,
          "data-qa": "company-name"
        }, null, 8 /* PROPS */, ["modelValue", "read-only"]))
      : _createCommentVNode("v-if", true),
    (!$options.isBusiness)
      ? (_openBlock(), _createBlock(_component_text_field, {
          key: 2,
          modelValue: $data.model.fullName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.fullName) = $event)),
          name: "model.fullName",
          "display-name": "Full Name",
          layout: "columns",
          description: "Name as shown on your ID document.",
          "read-only": $props.hasMoneyPayment,
          "data-qa": "full-name"
        }, null, 8 /* PROPS */, ["modelValue", "read-only"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_text_field, {
      modelValue: $data.model.email,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.model.email) = $event)),
      name: "model.email",
      "display-name": "Email address",
      layout: "columns",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "email"
    }, null, 8 /* PROPS */, ["modelValue", "read-only"]),
    _createVNode(_component_option_field, {
      modelValue: $data.model.twoLetterIsoCode,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = $event => (($data.model.twoLetterIsoCode) = $event)),
        $options.onCountryInput
      ],
      name: "model.twoLetterIsoCode",
      "display-name": "Country",
      layout: "columns",
      options: $options.countryOptions,
      "read-only": $props.hasMoneyPayment,
      "data-qa": "country"
    }, null, 8 /* PROPS */, ["modelValue", "options", "read-only", "onUpdate:modelValue"]),
    _createVNode(_component_text_field, {
      modelValue: $data.model.taxId,
      "onUpdate:modelValue": [
        _cache[5] || (_cache[5] = $event => (($data.model.taxId) = $event)),
        $options.onTaxIdChange
      ],
      name: "model.taxId",
      "display-name": "VAT ID/Tax Identification Number",
      layout: "columns",
      description: "Defines if the account belongs to an individual creator or a company.",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "tax-id"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "description", { class: "_mt-2" }, () => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_base_icon, {
              name: "circle-info",
              class: "_mr-1"
            }),
            _createElementVNode("span", null, _toDisplayString($props.taxIdFieldDescription), 1 /* TEXT */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, $options.isTaxIdDescriptionVisible]
          ])
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "read-only", "onUpdate:modelValue"]),
    _createVNode(_component_text_field, {
      modelValue: $data.model.street,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.model.street) = $event)),
      name: "model.street",
      "display-name": "Street",
      layout: "columns",
      description: "The name of the street.",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "street"
    }, null, 8 /* PROPS */, ["modelValue", "read-only"]),
    _createVNode(_component_text_field, {
      modelValue: $data.model.streetNumber,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.model.streetNumber) = $event)),
      name: "model.streetNumber",
      "display-name": "House/unit number",
      layout: "columns",
      description: "The number or name of the house.",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "house-number"
    }, null, 8 /* PROPS */, ["modelValue", "read-only"]),
    _createVNode(_component_text_field, {
      modelValue: $data.model.city,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.model.city) = $event)),
      name: "model.city",
      "display-name": "City",
      layout: "columns",
      description: "The name of the city.",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "city"
    }, null, 8 /* PROPS */, ["modelValue", "read-only"]),
    _createVNode(_component_text_field, {
      modelValue: $data.model.state,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.model.state) = $event)),
      name: "model.state",
      "display-name": "State",
      layout: "columns",
      description: "State or province.",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "state"
    }, null, 8 /* PROPS */, ["modelValue", "read-only"]),
    _createVNode(_component_text_field, {
      modelValue: $data.model.postalCode,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.model.postalCode) = $event)),
      name: "model.postalCode",
      "display-name": "Postal code",
      layout: "columns",
      description: "The postal code.",
      "read-only": $props.hasMoneyPayment,
      "data-qa": "postal-code"
    }, null, 8 /* PROPS */, ["modelValue", "read-only"])
  ]))
}